/* eslint-disable max-lines */
/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ['./public/index.html', './src/**/*.{js,jsx}'],
  theme: {
    colors: {
      // neutral light
      neutral: {
        25: '#FDFDFD',
        50: '#F9FAFA',
        75: '#F6F6F6',
        100: '#F5F5F5',
        200: '#E9EAEB',
        300: '#D5D7DA',
        400: '#A4A7AE',
        500: '#717680',
        600: '#535862',
        700: '#414651',
        800: '#252B37',
        900: '#181D27',
        950: '#0A0D12'
      },
      'neutral-dark': {
        25: '#FAFAFA',
        50: '#F7F7F7',
        100: '#F0F0F1',
        200: '#ECECED',
        300: '#CECFD2',
        400: '#94979C',
        500: '#85888E',
        600: '#61656C',
        700: '#373A41',
        800: '#22262F',
        900: '#13161B',
        950: '#0C0E12'
      },
      // blue light
      primary: {
        10: 'var(--color-primary-10, #FAFDFF)',
        25: 'var(--color-primary-25, #F5FBFF)',
        50: 'var(--color-primary-50, #F0F9FF)',
        100: 'var(--color-primary-100, #E0F2FE)',
        200: 'var(--color-primary-200, #B9E6FE)',
        300: 'var(--color-primary-300, #7CD4FD)',
        400: 'var(--color-primary-400, #36BFFA)',
        500: 'var(--color-primary-500, #0BA5EC)',
        600: 'var(--color-primary-600, #0086C9)',
        700: 'var(--color-primary-700, #026AA2)',
        800: 'var(--color-primary-800, #065986)',
        900: 'var(--color-primary-900, #0B4A6F)',
        950: 'var(--color-primary-950, #062C41)'
      },
      //error
      danger: {
        25: '#FFFBFA',
        50: '#FEF3F2',
        100: '#FEE4E2',
        200: '#FECDCA',
        300: '#FDA29B',
        400: '#F97066',
        500: '#F04438',
        600: '#D92D20',
        700: '#B42318',
        800: '#912018',
        900: '#7A271A',
        950: '#55160C'
      },
      // orange light
      warning: {
        25: '#FFFCF5',
        50: '#FFFAEB',
        100: '#FEF0C7',
        200: '#FEDF89',
        300: '#FEC84B',
        400: '#FDB022',
        500: '#F79009',
        600: '#DC6803',
        700: '#B54708',
        800: '#93370D',
        900: '#7A2E0E',
        950: '#4E1D09'
      },
      // green dark
      success: {
        25: '#F6FEF9',
        50: '#EDFCF2',
        100: '#D3F8DF',
        200: '#AAF0C4',
        300: '#73E2A3',
        400: '#3CCB7F',
        500: '#16B364',
        600: '#099250',
        700: '#087443',
        800: '#095C37',
        900: '#084C2E',
        950: '#052E1C'
      },
      moss: {
        25: '#FAFDF7',
        50: '#F5FBEE',
        100: '#E6F4D7',
        200: '#CEEAB0',
        300: '#ACDC79',
        400: '#86CB3C',
        500: '#669F2A',
        600: '#4F7A21',
        700: '#3F621A',
        800: '#335015',
        900: '#2B4212',
        950: '#1A280B'
      },
      'green-light': {
        25: '#FAFEF5',
        50: '#F3FEE7',
        100: '#E4FBCC',
        200: '#D0F8AB',
        300: '#A6EF67',
        400: '#85E13A',
        500: '#66C61C',
        600: '#4CA30D',
        700: '#3B7C0F',
        800: '#326212',
        900: '#2B5314',
        950: '#15290A'
      },
      teal: {
        25: '#F6FEFC',
        50: '#F0FDF9',
        100: '#CCFBEF',
        200: '#99F6E0',
        300: '#5FE9D0',
        400: '#2ED3B7',
        500: '#15B79E',
        600: '#0E9384',
        700: '#107569',
        800: '#125D56',
        900: '#134E48',
        950: '#0A2926'
      },
      cyan: {
        25: '#F5FEFF',
        50: '#ECFDFF',
        100: '#CFF9FE',
        200: '#A5F0FC',
        300: '#67E3F9',
        400: '#22CCEE',
        500: '#06AED4',
        600: '#088AB2',
        700: '#0E7090',
        800: '#155B75',
        900: '#164C63',
        950: '#0D2D3A'
      },
      'blue-dark': {
        25: '#F5F8FF',
        50: '#EFF4FF',
        100: '#D1E0FF',
        200: '#B2CCFF',
        300: '#84ADFF',
        400: '#528BFF',
        500: '#2970FF',
        600: '#155EEF',
        700: '#004EEB',
        800: '#0040C1',
        900: '#00359E',
        950: '#002266'
      },
      violet: {
        25: '#FBFAFF',
        50: '#F5F3FF',
        100: '#ECE9FE',
        200: '#DDD6FE',
        300: '#C3B5FD',
        400: '#A48AFB',
        500: '#875BF7',
        600: '#7839EE',
        700: '#6927DA',
        800: '#5720B7',
        900: '#491C96',
        950: '#2E125E'
      },
      purple: {
        25: '#FAFAFF',
        50: '#F4F3FF',
        100: '#EBE9FE',
        200: '#D9D6FE',
        300: '#BDB4FE',
        400: '#9B8AFB',
        500: '#7A5AF8',
        600: '#6938EF',
        700: '#5925DC',
        800: '#4A1FB8',
        900: '#3E1C96',
        950: '#27115F'
      },
      fuchsia: {
        25: '#FEFAFF',
        50: '#FDF4FF',
        100: '#FBE8FF',
        200: '#F6D0FE',
        300: '#EEAAFD',
        400: '#E478FA',
        500: '#D444F1',
        600: '#BA24D5',
        700: '#9F1AB1',
        800: '#821890',
        900: '#6F1877',
        950: '#47104C'
      },
      pink: {
        25: '#FEF6FB',
        50: '#FDF2FA',
        100: '#FCE7F6',
        200: '#FCCEEE',
        300: '#FAA7E0',
        400: '#F670C7',
        500: '#EE46BC',
        600: '#DD2590',
        700: '#C11574',
        800: '#9E165F',
        900: '#851651',
        950: '#4E0D30'
      },
      rose: {
        25: '#FFF5F6',
        50: '#FFF1F3',
        100: '#FFE4E8',
        200: '#FECDD6',
        300: '#FEA3B4',
        400: '#FD6F8E',
        500: '#F63D68',
        600: '#E31B54',
        700: '#C01048',
        800: '#A11043',
        900: '#89123E',
        950: '#510B24'
      },
      'orange-dark': {
        25: '#FFF9F5',
        50: '#FFF4ED',
        100: '#FFE6D5',
        200: '#FFD6AE',
        300: '#FF9C66',
        400: '#FF692D',
        500: '#FF4405',
        600: '#E62E05',
        700: '#BC1B06',
        800: '#97180C',
        900: '#771A0D',
        950: '#57130A'
      },
      yellow: {
        25: '#FEFDF0',
        50: '#FEFBE8',
        100: '#FEF7C3',
        200: '#FEEE95',
        300: '#FDE272',
        400: '#FAC515',
        500: '#EAAA08',
        600: '#CA8504',
        700: '#A15C07',
        800: '#854A0E',
        900: '#713B12',
        950: '#542C0D'
      },
      black: '#000000',
      white: '#FFFFFF',
      transparent: 'transparent'
    },
    extend: {
      transitionDuration: { fast: '120ms', enter: '180ms', standard: '200ms' },
      transitionTimingFunction: { standard: 'cubic-bezier(0.2, 0, 0, 1)' },
      fontFamily: {
        apple: [
          'Geist',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif'
        ]
      },
      fontWeight: { 400: 400, 500: 500, 600: 600, 700: 700, 800: 800 },
      fontSize: { xxs: '0.625rem' },
      boxShadow: {
        xxs: '0px -2px 24px rgba(42, 92, 138, 0.08)',
        xs: '0px 2px 16px rgba(0,79,107,0.2)',
        small: '0 4px 16px 0px rgba(10,18,57,0.03)',
        medium: '0 0px 24px 0px rgba(0,79,107,0.16)',
        'card-selected': '0px 0px 0px 2px rgba(203, 240, 253, 1)',
        'spread-medium': '0px 0px 16px 2px rgba(65, 70, 81, 0.12)'
      },
      keyframes: {
        fadeIn_pulse: { '0%': { opacity: '0' }, '50%': { opacity: '0' }, '100%': { opacity: '1' } },
        shake: {
          '0%, 50%, 100%': { transform: 'translateX(0)' },
          '6%, 19%': { transform: 'translateX(-2px)' },
          '12%': { transform: 'translateX(2px)' },
          '31%, 44%': { transform: 'translateX(-1px)' },
          '25%, 38%': { transform: 'translateX(1px)' }
        },
        // Insurance verification ring/progress (checkin "Calculate GFE").
        breathe: {
          '0%, 100%': { opacity: '0.1', transform: 'scale(1)' },
          '50%': { opacity: '0.25', transform: 'scale(1.04)' }
        },
        shimmer: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(340px)' }
        },
        'check-bounce': {
          '0%': { transform: 'scale(0)' },
          '60%': { transform: 'scale(1.15)' },
          '100%': { transform: 'scale(1)' }
        },
        // Screen-entrance: content fades while rising into place.
        'enter-up': {
          '0%': { opacity: '0', transform: 'translateY(16px)' },
          '100%': { opacity: '1', transform: 'translateY(0)' }
        },
        // Panel-entrance: slides in from the right edge while fading.
        'enter-right': {
          '0%': { opacity: '0', transform: 'translateX(32px)' },
          '100%': { opacity: '1', transform: 'none' }
        },
        // Focal-element entrance: scales in with a soft overshoot.
        'pop-in': {
          '0%': { opacity: '0', transform: 'scale(0.4)' },
          '60%': { opacity: '1', transform: 'scale(1.08)' },
          '100%': { opacity: '1', transform: 'scale(1)' }
        },
        'fade-in': { '0%': { opacity: '0' }, '100%': { opacity: '1' } },
        // Floating-surface entrance (popover, select menu, calendar): quick fade + slight scale from the anchor edge.
        // Uses the individual `scale`/`translate` properties (not `transform`) so it
        // composes with inline `transform` positioning instead of overriding it.
        'float-in': {
          '0%': { opacity: '0', scale: '0.97', translate: '0 -8px' },
          '100%': { opacity: '1', scale: '1', translate: '0 0' }
        },
        // Radar pulse: ring expands and fades.
        'ring-burst': {
          '0%': { opacity: '0.55', transform: 'scale(0.55)' },
          '100%': { opacity: '0', transform: 'scale(2.1)' }
        },
        sweep: {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(100%)' }
        },
        scale_pulse: {
          '0%, 100%': { transform: 'scale(0.85)' },
          '50%': { transform: 'scale(1)' }
        }
      },
      animation: {
        'fade-in-pulse': 'fadeIn_pulse 0.5s ease-in forwards, pulse 1.5s infinite 0.5s',
        shake: 'shake 2s ease-in-out infinite',
        'scale-pulse': 'scale_pulse 1.5s ease-in-out infinite',
        breathe: 'breathe 2.5s ease-in-out infinite',
        shimmer: 'shimmer 1.5s ease-in-out infinite',
        'check-bounce': 'check-bounce 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
        // `backwards` (not `both`): no retained end transform, so no stacking context
        // traps popovers (e.g. the date-picker calendar behind the QR). -1/-2/-3 stagger.
        'enter-up': 'enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) backwards',
        'enter-up-1': 'enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.1s backwards',
        'enter-up-2': 'enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.22s backwards',
        'enter-up-3': 'enter-up 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.34s backwards',
        'enter-right': 'enter-right 0.55s cubic-bezier(0.22, 1, 0.36, 1) 0.34s backwards',
        'pop-in': 'pop-in 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s backwards',
        // No fill mode: transform is released after the animation so the panel doesn't
        // become a containing block for nested fixed/portal content.
        'float-in': 'float-in 0.15s cubic-bezier(0.16, 1, 0.3, 1)',
        'fade-in': 'fade-in 0.15s ease-out',
        // No fill: stays hidden (base opacity-0) before/after, leaving no retained transform.
        'ring-burst': 'ring-burst 0.9s ease-out 0.4s',
        sweep: 'sweep 1.8s ease-in-out infinite'
      },
      backgroundImage: {
        'white-to-primary': 'linear-gradient(90deg, rgb(222 245 255) 32%, rgb(181 233 255) 100%)',
        'primary-to-white':
          'linear-gradient(90.01deg, #f0f9ff 0%, rgba(240, 249, 255, 0.24) 56.77%, #ffffff 82.66%, #ffffff 103.58%)',
        'success-to-white':
          'linear-gradient(90.01deg, #edfcf2 0%, rgba(237, 252, 242, 0.24) 56.77%, #ffffff 82.66%, #ffffff 103.58%)'
      }
    },
    // Desktop-first: ordered largest → smallest so the CSS cascade resolves
    screens: {
      xxl: { min: '1920px' },
      xl: { max: '1919px' },
      lg: { max: '1439px' },
      md: { max: '1279px' },
      sm: { max: '1023px' },
      xs: { max: '599px' },
      xxs: { max: '389px' }
    },
    listStyleType: {
      none: 'none',
      disc: 'disc',
      decimal: 'decimal',
      square: 'square',
      roman: 'upper-roman'
    }
  },
  safelist: [
    'text-[color:var(--color-on-primary,#fff)]',
    'disabled:text-[color:var(--color-on-primary,#fff)]',
    // Typography builds `text-${color}` dynamically, which JIT can't see —
    // shades outside the text-* patterns below must be listed explicitly.
    'text-neutral-800',
    'text-neutral-dark-300',
    {
      pattern:
        /bg-(neutral|primary|secondary|warning|success|danger|moss|purple)-(25|50|75|100|200|300|400|500|600|700|800|900)/
    },
    {
      pattern:
        /bg-(neutral|primary|secondary|warning|success|danger|moss|purple)-(25|50|75|100|200|400|500|600|700)/,
      variants: ['hover', 'active', 'disabled']
    },
    {
      pattern:
        /text-(neutral|primary|secondary|warning|success|danger|moss|purple)-(25|50|75|100|200|400|500|600|700)/,
      variants: ['hover', 'active', 'disabled']
    },
    {
      pattern:
        /border-(neutral|primary|secondary|warning|success|danger|moss|purple)-(25|50|75|100|200|400|500|600|700)/,
      variants: ['hover', 'active', 'disabled']
    }
  ],
  corePlugins: { preflight: false }
};
